import React from 'react';
// Vendor hooks.
import { useTranslation } from 'react-i18next';

import * as S from './styled';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <S.Footer>
      <S.Info>
        <S.Content>{t('core:footer.iso')}</S.Content>
        <S.Content>{t('core:footer.copyright')}</S.Content>
      </S.Info>
      <S.Links>
        <S.Link href={t('core:footer.link.status.href')}>
          {t('core:footer.link.status.title')}
        </S.Link>
        <S.Separator />
        <S.Link href={t('core:footer.link.terms.href')}>{t('core:footer.link.terms.title')}</S.Link>
        <S.Separator />
        <S.Link href={t('core:footer.link.privacy.href')}>
          {t('core:footer.link.privacy.title')}
        </S.Link>
      </S.Links>
    </S.Footer>
  );
};

export default Footer;
